export enum STATE {
  'IDLE' = 'IDLE',
  'LOADING' = 'LOADING',
  'LOADED' = 'LOADED',
  'FAILED' = 'FAILED',
}
